import React from 'react';
import PropTypes from 'prop-types';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/loader/Loader.scss';

const Loader = (props) => {
  const { loaderMessage, className, isAnimated = false } = props;
  if (!loaderMessage) {
    return null;
  }

  const loaderClassName = `csw-loader ${className ? className : ''} ${isAnimated ? 'csw-loader-animated': ''}`;

  return (
    <div {...props} className={loaderClassName}>
      <div className="csw-loader-text" title={loaderMessage}>{loaderMessage}</div>
      {isAnimated && <div className="csw-loader-anim" aria-hidden="true" />}
    </div>
  );
};

Loader.propTypes /* remove-proptypes */ = {
  loaderMessage: PropTypes.string.isRequired,
  className: PropTypes.string,
  isAnimated: PropTypes.bool
};

export default Loader;
